const state = {
	selectedLocationId: null,
	locations: [],
	isLocationDialogOpen: false
}

const getters = {
	getSelectedLocationId: (state) => {
		return state.selectedLocationId
	},
  
	hasSelectedLocation: (state) => {
		return state.selectedLocationId !== null
	}
}

const mutations = {
	SET_SELECTED_LOCATION(state, locationId) {
		state.selectedLocationId = locationId
		localStorage.setItem('selectedLocationId', locationId.toString())
	},

	SET_LOCATIONS(state, locations) {
		state.locations = locations
	},

	OPEN_LOCATION_DIALOG(state) {
		state.isLocationDialogOpen = true
	},

	CLOSE_LOCATION_DIALOG(state) {
		state.isLocationDialogOpen = false
	},

	LOAD_SELECTED_LOCATION_FROM_STORAGE(state) {
		const storedLocationId = localStorage.getItem('selectedLocationId')
		if (storedLocationId) {
			state.selectedLocationId = parseInt(storedLocationId)
		}
	},

	CLEAR_SELECTED_LOCATION(state) {
		state.selectedLocationId = null
		localStorage.removeItem('selectedLocationId')
	}
}

const actions = {
	setSelectedLocation({ commit }, locationId) {
		commit('SET_SELECTED_LOCATION', locationId)
	},

	setLocations({ commit }, locations) {
		commit('SET_LOCATIONS', locations)
	},

	openLocationDialog({ commit }) {
		commit('OPEN_LOCATION_DIALOG')
	},

	closeLocationDialog({ commit }) {
		commit('CLOSE_LOCATION_DIALOG')
	},

	loadSelectedLocationFromStorage({ commit }) {
		commit('LOAD_SELECTED_LOCATION_FROM_STORAGE')
	},

	clearSelectedLocation({ commit }) {
		commit('CLEAR_SELECTED_LOCATION')
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}